var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6901 7.45503V4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6686 15.9152C29.6686 17.5105 30.9497 18.0423 32.69 18.0423C34.4304 18.0423 35.7114 18.0423 35.7114 15.9152C35.7114 12.7487 29.6686 12.7487 29.6686 9.58226C29.6686 7.45517 30.9497 7.45517 32.69 7.45517C34.4304 7.45517 35.7114 8.25283 35.7114 9.58226",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6901 18.042V21.2084",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12286 11.54H6.70572C5.37077 11.54 4.28857 12.6222 4.28857 13.9572V24.8343C4.28857 26.1692 5.37077 27.2514 6.70572 27.2514H9.12286C10.4578 27.2514 11.54 26.1692 11.54 24.8343V13.9572C11.54 12.6222 10.4578 11.54 9.12286 11.54Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91431 27.2514V30.8771",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91431 11.54V4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4172 21.2086H20C18.6651 21.2086 17.5829 22.2908 17.5829 23.6257V27.2514C17.5829 28.5864 18.6651 29.6686 20 29.6686H22.4172C23.7521 29.6686 24.8343 28.5864 24.8343 27.2514V23.6257C24.8343 22.2908 23.7521 21.2086 22.4172 21.2086Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2086 29.6686V35.7114",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2086 21.2086V12.7486",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStockOutline);
export default __webpack_public_path__ + "static/media/icon_stock_outline.07fdb6d723b13c8c547c98b6d7016e0e.svg";
export { ForwardRef as ReactComponent };